<template>
  <div>
    <b-modal
      :body-class="{ static: hoverTool }"
      id="modal-manage-footer-menu"
      scrollable
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      @shown="modalShown"
    >
      <template #modal-header>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="modal-title">
             {{$t("engine.manageFooter.modal.lblTitle", languageEngine)}}
              {{ languageUse && languageUse.toUpperCase() }}
              <i
                :class="`flag-icon flag-icon-${
                  languages &&
                  languages[languageUse] &&
                  languages[languageUse].flagIcon
                }`"
              ></i>
            </h5>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="close mr-0 pr-10" type="button" style="font-size: 16px">
           <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            type="button"
            aria-label="Close"
            id="close-modal-manage-footer-menu"
            class="close-modal"
            style="font-size: 24px;"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </template>
      <template>
        <div class="manage-menu-footer-wrapper">
          <div class="side-group">
            <div v-b-tooltip.hover.left="{ disabled: lenghtRootData < 4}" :title="$t('engine.manageFooter.manu.lblAddMenuSet.limit',languageEngine)" style="width: fit-content">
              <b-button
                :disabled="lenghtRootData >= 4"
                variant="default" 
                @click="addMenuSet"
                >
                <i class="fas fa-plus mr-gd-half"></i>{{$t("engine.manageFooter.manu.lblAddMenuSet",languageEngine)}}
                </b-button
              >
            </div>
            <div>
              <MenuSet
                v-if="lenghtRootData > 0 && renderMenuSet"
                v-model="activeSet"
                @edit="setEditMenuSet"
                @preDelete="preDeleteMenuSet"
              />
              <div v-else class="help-empty text-center">
                {{$t("engine.manageFooter.manu.lblDescriptAddMenuSet",languageEngine )}}
              </div>
            </div>
          </div>
          <div class="menu-list">
            <div>
              <b-button variant="blue" @click="addMenu">
                <i class="fas fa-plus mr-gd-half"></i>{{$t("engine.manageFooter.manu.lblAddMenu",languageEngine)}}
              </b-button>
            </div>
            <Menu
              class="overflow-y-auto overflow-x-hidden"
              v-if="activeSet && renderMenu"
              :activeMainId="activeSet"
              @edit="setEditMenu"
              @preDelete="preDeleteMenu"
              @mouseoverCustom="mouseover"
              @mouseleaveCustom="mouseleave"
            />
          </div>
        </div>
      </template>
    </b-modal>
    <AddMenuSet
      :action="itemMenuSetAction"
      :id="item_id"
      @setMenuSetActive="(value) => menuSetActiveIDRemeber = value"
      @clear="clear"
    />
    <AddMenu
      :action="itemMenuAction"
      :paren_id="activeSet"
      :id="item_id"
      @setMenuSetActive="(value) => menuSetActiveIDRemeber = value"
      @clear="clear"
    />
    <ConfirmDeleteMenuSet
      :item_name="item_name"
      @confirmed="deleteMenuSet(item_id)"
      @clear="(item_id = ''), (item_name = '')"
    />
    <ConfirmDeleteMenu
      :item_name="item_name"
      @confirmed="deleteMenu(item_id)"
      @clear="(item_id = ''), (item_name = '')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MenuSet from "./MenuSet/MenuSet";
import Menu from "./Menu/Menu";

import AddMenuSet from "./AddMenuSet/AddMenuSet";
import AddMenu from "./AddMenu/AddMenu";
import ConfirmDeleteMenuSet from "./dialogConfirmDelete.vue";
import ConfirmDeleteMenu from "./dialogConfirmDeleteMenu.vue";

export default {
  data() {
    return {
      activeSet: "",
      itemMenuSetAction: "add",
      menuSetActiveIDRemeber: undefined, // ใช้เก็บค่่าในกรณีที่ต้องการให้เมื่อเปิด modal อีกครั้งแล้วยัง active menu set เดิมอยู่
      item_id: "",
      item_name: "",
      itemMenuAction: "add",
      hoverTool: false,
      renderMenuSet: true,
      renderMenu: true,
    };
  },
  components: {
    MenuSet,
    Menu,
    AddMenuSet,
    AddMenu,
    ConfirmDeleteMenuSet,
    ConfirmDeleteMenu,
  },
  computed: {
    ...mapGetters({
      languages: "design/site/languages",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      modal: "design/modal",
      siteComponents: "design/metadata/siteComponents",
    }),
    menu() {
      return this.siteComponents.FOOTER_WIDGET_MENU;
    },
    lenghtRootData() {
      return this.menu && this.menu.componentsID.length;
    },
    lenghtChildrenactiveSection() {
      if (
        this.siteComponents !== undefined &&
        this.siteComponents !== {} &&
        this.activeSet !== ""
      ) {
        return (
          this.siteComponents &&
          this.siteComponents[this.activeSet] &&
          this.siteComponents[this.activeSet].componentsID &&
          this.siteComponents[this.activeSet].componentsID.length
        );
      }
      return 0;
    },
  },
  watch: {
    menu() {
      this.initAllMenu()
    },
    modal: {
      handler() {
        if (this.modal == "modal-manage-footer-menu") {
          this.$bvModal.show("modal-manage-footer-menu");
        }
      },
    },
    activeSet: {
      handler() {
        if (!this.activeSet) {
          this.setActiveDefault();
        }
      }
    }
  },
  methods: {
    initAllMenu() {
      this.renderMenuSet = false;
      this.renderMenu = false;
      this.$nextTick(() => {
        this.renderMenuSet = true;
        this.renderMenu = true;
      })
      if (this.menuSetActiveIDRemeber && Object.prototype.hasOwnProperty.call(this.siteComponents, this.menuSetActiveIDRemeber)) {
        this.activeSet = this.menuSetActiveIDRemeber
        this.menuSetActiveIDRemeber = undefined;
      } else {
        this.setActiveDefault()
      }
    },
    modalShown() {
      this.initAllMenu()
    },
    closeModal() {
      this.activeSet = undefined;
      this.menuSetActiveIDRemeber = undefined;
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide("modal-manage-footer-menu");
    },
    clear() {
      this.itemMenuSetAction = ''
      this.itemMenuAction = ''
      this.initAllMenu()
    },
    mouseover() {
      this.hoverTool = false;
    },
    mouseleave() {
      this.hoverTool = false;
    },
    setActiveDefault() {
      if (this.menu) {
        this.activeSet = this.menu.componentsID[0];
      }
    },
    addMenuSet() {
      this.itemMenuSetAction = "add";
      this.menuSetActiveIDRemeber = this.activeSet
      if (this.lenghtRootData < 4) {
        this.$bvModal.show("modal-menuset-footer");
      }
    },
    addMenu() {
      this.itemMenuAction = "add";
      this.menuSetActiveIDRemeber = this.activeSet
      this.$bvModal.show("modal-footer-menu");
    },
    setEditMenuSet(id) {
      this.itemMenuSetAction = "edit";
      this.item_id = id;
      this.menuSetActiveIDRemeber = id
      this.$bvModal.show("modal-menuset-footer");
    },
    setEditMenu(id) {
      this.itemMenuAction = "edit";
      this.item_id = id;
      this.menuSetActiveIDRemeber = this.activeSet
      this.$bvModal.show("modal-footer-menu");
    },
    preDeleteMenuSet(item) {
      this.item_id = item.id;
      this.item_name = item.properties.name;
      this.menuSetActiveIDRemeber = this.activeSet
      this.$bvModal.show("modal-confirm-delete-menu-set-footer");
    },
    deleteMenuSet(id) {
      if (this.siteComponents[id].componentsID.length == 0) {
        delete this.siteComponents[id];
        const index =
          this.siteComponents.FOOTER_WIDGET_MENU.componentsID.findIndex(
            (item) => item == id
          );
        this.siteComponents.FOOTER_WIDGET_MENU.componentsID.splice(index, 1);
        this.$emit(
          "input",
          this.siteComponents.FOOTER_WIDGET_MENU.componentsID[0]
        );
        this.$store.dispatch("design/snapshot/genSnapshot", {
          type: "menu_set",
        });
        this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t("engine.manageFooter.menu.alert.msgDeleteMenuSetSuccess", this.languageEngine) });
        this.initAllMenu()
      }
    },
    preDeleteMenu(item) {
      this.item_id = item.id;
      this.item_name = item.properties.name;
      this.menuSetActiveIDRemeber = this.activeSet
      this.$bvModal.show("modal-confirm-delete-menu-footer");
    },
    deleteMenu(id) {
        delete this.siteComponents[id];
        const index = this.siteComponents[this.activeSet].componentsID.findIndex(
          (item) => item == id
        );
        this.siteComponents[this.activeSet].componentsID.splice(index, 1);
        this.$store.dispatch("design/snapshot/genSnapshot", { type: "menu" });
        this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine),  message:this.$t("engine.manageFooter.menu.alert.msgDeleteMenuSuccess", this.languageEngine) });
        this.initAllMenu()
    },
  },
};
</script>

<style lang="scss">
/* .modal-dialog-scrollable .modal-body */
#modal-manage-footer-menu {
  .modal-dialog-scrollable .modal-content{
    overflow: unset !important;
  }
  /* Customize website's scrollbar like Mac OS
  Not supports in Firefox and IE */

  /* total width */
  ::-webkit-scrollbar {
    background-color: #fff;
    width: 16px;
  }

  /* background of the scrollbar except button or resizer */
  ::-webkit-scrollbar-track {
    background-color: #fff;
  }

  /* scrollbar itself */
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }

  /* set button(top and bottom of the scrollbar) */
  ::-webkit-scrollbar-button {
    display: none;
  }
  .modal-header {
    padding: 16px 24px;
    .icon-question {
      font-size: 18px;
      /* width: 20px; */
      /* height: 20px; */
      color: rgba(0, 0, 0, 0.5);
    }
    .icon-close-modal {
      font-size: 24px;
      /* width: 24px; */
      /* height: 24px; */
      color: rgba(0, 0, 0, 0.5);
    }
    .modal-title {
      display: flex;
      align-items: center;
      font-family: 'MWE_DB_Heavent';
      font-weight: normal;
      font-size: 28px;
      line-height: 1.2;
      color: #4F5963;
      .flag-icon {
        height: 16px;
        margin-top: -2px;
      }
    }
  }
  .modal-body {
    /* padding: 15px 15px 15px 30px; */
    display: contents;
  }
  .overflow-y-auto {
    overflow-y: auto !important;
  }
  .overflow-x-hidden {
    overflow-x: hidden !important;
  }
  .manage-menu-footer-wrapper {
    display : flex;
    padding: 16px 32px;
    overflow-y: hidden;
    .side-group {
      flex : 40%;
      border-right : 1px solid #DEE3E6;
      padding-right: 16px;
    }
    .menu-list { 
      flex : 60%;
      height: 100%;
      padding-left: 16px;
    }
    .help-empty {
      margin-top: 8px;
      margin-bottom: 8px;
      position: relative;
      display: block;
      padding: .5rem .75rem .5rem .6rem;
      background-color: #fff;
      border: 1px solid #DEE3E6;
      border-radius: 4px;
    }
    .option {
      &:hover {
        background-color: #f4fcff;
      }
    }
  }
}
#modal-manage-footer-menu___BV_modal_body_ {
  position: static;
}
.modal-body.static .nestable,
.modal-body.static .nestable-item {
  position: static;
}
.modal-body.static .nestable-item .handler::before,
.modal-body.static .nestable-item .handler::after {
  display: none;
}
</style>
